import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useMatchmaking } from "@/hooks/useMatchmaking";
import { useAuth } from "@/hooks/useAuth";
import { MatchmakingDialog } from "@/components/MatchmakingDialog";
import { Zap, Loader2 } from "lucide-react";

export function QuickPlayButton() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { joinQueue, isSearching, isInQueue } = useMatchmaking();
  const [showMatchmaking, setShowMatchmaking] = useState(false);

  const handleQuickPlay = async () => {
    if (!user) {
      navigate("/auth");
      return;
    }
    
    setShowMatchmaking(true);
    await joinQueue("5+0");
  };

  const handleMatchFound = (
    gameSessionId: string,
    timeControl: string,
    playerColor: 'white' | 'black',
    isBot?: boolean,
    botElo?: number
  ) => {
    setShowMatchmaking(false);
    navigate(`/?game=${gameSessionId}&mode=direct`);
  };

  return (
    <>
      <Card className="bg-gradient-to-br from-accent/20 via-accent/10 to-transparent border-accent shadow-lg">
        <CardContent className="p-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-center md:text-left">
            <h3 className="text-xl md:text-2xl font-bold text-accent flex items-center gap-2 justify-center md:justify-start">
              <Zap className="w-6 h-6" />
              Ready to Play?
            </h3>
            <p className="text-muted-foreground mt-1">
              Find an opponent instantly - one click and you're in!
            </p>
          </div>
          <Button 
            size="lg" 
            onClick={handleQuickPlay}
            disabled={isSearching || isInQueue}
            className="bg-accent hover:bg-accent/90 text-accent-foreground min-w-[200px] shadow-lg hover:shadow-xl transition-all"
          >
            {isSearching || isInQueue ? (
              <>
                <Loader2 className="mr-2 h-5 w-5 animate-spin" />
                Searching...
              </>
            ) : (
              <>
                <Zap className="mr-2 h-5 w-5" />
                Quick Play
              </>
            )}
          </Button>
        </CardContent>
      </Card>

      <MatchmakingDialog
        open={showMatchmaking}
        onOpenChange={setShowMatchmaking}
        onMatchFound={handleMatchFound}
      />
    </>
  );
}
